import FraInspectionContainer from './containers/FraInspectionContainer';

export default FraInspectionContainer;
export {uiDataFraInspection, serverDataFraInspection} from './reducers/FraInspectionReducer';

